/* esm.sh - @lit/reactive-element@1.6.3/decorators/custom-element */
var c=s=>t=>typeof t=="function"?((n,e)=>(customElements.define(n,e),e))(s,t):((n,e)=>{let{kind:m,elements:o}=e;return{kind:m,elements:o,finisher(i){customElements.define(n,i)}}})(s,t);export{c as customElement};
/*! Bundled license information:

@lit/reactive-element/decorators/custom-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=custom-element.mjs.map